const loggedIn = (() => {

    const initBlock = (el) => {
        const username = el.querySelector('#username');              
        const targetNode = username;
        const config = {childList: true};
        const callback = function (mutationsList, observer) {
            for (var mutation of mutationsList) {
                if (mutation.type == 'childList') {
                    loginCheck(el, username)
                }
            }
        };
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
    };
    
    const loginCheck = (el, username) => {
        if (username.innerHTML === "") {
            el.classList.add('logged-in-message--hidden');
        } else {
            el.classList.remove('logged-in-message--hidden');
        }
    }


    return {initBlock};
})();

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.logged-in-message').forEach(el => loggedIn.initBlock(el));
});